export const cursor = { fill: '#f3fdff', stroke: '#9eb9bd', strokeWidth: 1 }
